/**
 * Maps a property display name to the AI Host Agent property_id slug.
 * "Aurum" → "aurum", "Casa Oro" → "casa-oro"
 */
export function toPropertyId(propertyName) {
  if (propertyName == null) {
    return ''
  }

  return String(propertyName)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/**
 * Splits a room nickname into property name + room label.
 * "Aurum - A" → { propertyName: "Aurum", roomLabel: "A" }
 * "Casa Oro A" → { propertyName: "Casa Oro", roomLabel: "A" }
 */
export function parseRoomAssignment(room) {
  if (!room || typeof room !== 'string') {
    return { propertyName: '', roomLabel: '' }
  }

  const trimmed = room.trim()
  if (!trimmed || trimmed === 'Not Assigned') {
    return { propertyName: '', roomLabel: '' }
  }

  if (trimmed.includes(' - ')) {
    const [propertyName, ...rest] = trimmed.split(' - ')
    return {
      propertyName: propertyName.trim(),
      roomLabel: rest.join(' - ').trim()
    }
  }

  const letterSuffix = trimmed.match(/^(.*)\s+([A-Za-z])$/)
  if (letterSuffix) {
    return {
      propertyName: letterSuffix[1].trim(),
      roomLabel: letterSuffix[2]
    }
  }

  return { propertyName: '', roomLabel: trimmed }
}

/**
 * Builds the POST /chat `context` object expected by ai-host-agent.
 */
export function buildChatContext({
  propertyName,
  room,
  guestName,
  source,
  provider,
  model
} = {}) {
  const parsed = parseRoomAssignment(room)
  const resolvedPropertyName = String(
    propertyName || parsed.propertyName || ''
  ).trim()
  const propertyId = toPropertyId(resolvedPropertyName)
  const resolvedRoom = String(room || '').trim()

  const context = {
    source: source || 'widget'
  }

  if (propertyId) {
    context.property_id = propertyId
  }
  if (resolvedPropertyName) {
    context.property_name = resolvedPropertyName
  }
  if (resolvedRoom && resolvedRoom !== 'Not Assigned') {
    context.room = resolvedRoom
  }
  if (guestName) {
    context.guest_name = guestName
  }
  if (provider) {
    context.provider = provider
  }
  if (model) {
    context.model = model
  }

  return context
}
